import {RouteModule} from '@/types/route-type';
import Info from '@/pages/info';
import Recommend from '@/pages/recommend';
import Hold from '@/pages/hold';
import Fund from '@/pages/fund';
import Report from '@/pages/report';

const AllModule: RouteModule[] = [Info, Recommend, Hold, Fund, Report];

export default AllModule;
